export default "__VITE_ASSET__u7MUjbP3__"